/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlStripeGetPriceResponse
 */
export interface ControlStripeGetPriceResponse {
    /**
     * 
     * @type {number}
     * @memberof ControlStripeGetPriceResponse
     */
    price: number;
    /**
     * 
     * @type {string}
     * @memberof ControlStripeGetPriceResponse
     */
    currency: string;
}

/**
 * Check if a given object implements the ControlStripeGetPriceResponse interface.
 */
export function instanceOfControlStripeGetPriceResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "price" in value;
    isInstance = isInstance && "currency" in value;

    return isInstance;
}

export function ControlStripeGetPriceResponseFromJSON(json: any): ControlStripeGetPriceResponse {
    return ControlStripeGetPriceResponseFromJSONTyped(json, false);
}

export function ControlStripeGetPriceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlStripeGetPriceResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'price': json['price'],
        'currency': json['currency'],
    };
}

export function ControlStripeGetPriceResponseToJSON(value?: ControlStripeGetPriceResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'price': value.price,
        'currency': value.currency,
    };
}

